import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../core/core.module';
import { ImageEditorComponent } from './image-editor/image-editor.component';
import { ImageEditorToolComponent } from './image-editor-tool/image-editor-tool.component';
import { ForgotEmailComponent } from './forgot-email/forgot-email.component';
import { IdentificationCommentsComponent } from './identification-comments/identification-comments.component';
import { UserIdentificationCommentsComponent } from './user-identifications/user-identifications.component';

import { LyIconModule } from '@alyle/ui/icon';
import { LySliderModule } from '@alyle/ui/slider';
import { ViewImgComponent } from './view-img/view-img.component';
import { NgMagnizoomModule } from 'ng-magnizoom';
import { CoinDetailCaptureComponent } from './coin-detail-capture/coin-detail-capture.component';
const SharedList = [
    ImageEditorComponent,
    ImageEditorToolComponent,
    ViewImgComponent
]

@NgModule({
  declarations: [SharedList, ForgotEmailComponent, IdentificationCommentsComponent, UserIdentificationCommentsComponent,CoinDetailCaptureComponent],
  imports: [
    CoreModule,
    NgMagnizoomModule,
    LySliderModule,
    LyIconModule,
    CommonModule
  ],
  exports: [
    SharedList
  ]

})
export class PopupsModule { }
